module.exports = __webpack_public_path__ + "img/zxdy.ab6e13b5.png";